<template>
  <div class="as-wrapper">
    <ApplicationServiceV2
      :list-url="listUrl"
      :delete-url="deleteUrl"
      :exportServiceUrl="exportServiceUrl"
      :importServiceInfoUrl='importServiceInfoUrl'
      :offline-service-url="offlineServiceUrl"
      :request="request"
      @on-operate="onOperate"
      @on-haveGuide="onHaveGuide"
      :showWanmei='showWanmei'
    />
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import configR from '@/configs.js';
  export default {
    name: "ApplicationServiceManagement",
    computed: {
      ...mapGetters(["serveUrl", "token", "request"]),
      listUrl() {
        return `${configR.envConfigs.PORTAL_API}v2/service/manage/getServiceInfo`;
      },
      deleteUrl() {
        return `${configR.envConfigs.PORTAL_API}v1/service/delService`;
      },
      offlineServiceUrl() {
        return `${configR.envConfigs.PORTAL_API}v1/service/manage/offlineService`;
      },
      exportServiceUrl() {
        return `${configR.envConfigs.PORTAL_API}v1/service/exportForService`;
      },
      importServiceInfoUrl() {
        return `${configR.envConfigs.PORTAL_API}v1/service/importServiceInfo`;
      },
      showWanmei() {
        return configR.envConfigs.SHOW_WEI_MEI;
      },
    },
    methods: {
      onOperate(data, action) {
        console.error("data", data);

        switch (action) {
          case "new":
            this.$router.push({
              name: data === "app" ? "CreateApplication" : "CreateService",
            });
            break;
          case "edit":
            this.$router.push({
              name: data.serviceType === "4" ? "EditApplication" : "EditService",
              query: {
                id: data.id,
              },
            });
            break;
          case "basisEdit":
            this.$router.push({
              name: data.serviceType === "4" ? "EditApplication" : "EditService",
              query: {
                basisId: data.id,
              },
            });
            break;
          case "view":
            this.$router.push({
              name: data.serviceType === "4" ? "ViewApplication" : "ViewService",
              query: {
                id: data.id,
              },
            });
            break;
          case "shelf":
            this.$router.push({
              name: "ShelfApplicationService",
              query: {
                id: data.id,
              },
            });
            break;
          case "terminal":
            this.$router.push({
              name: "AddTerminal",
              query: {
                id: data.id,
              },
            });
            break;
          default:
            break;
        }
      },
      onHaveGuide(id,yyid) {
        this.$router.push({
          name: "CreateApplication",
          query: {
            haveGuide: id,
            yyid:yyid,
          },
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .as-wrapper {
    padding: 28px 20px;
    background-color: rgba(255, 255, 255, 1);
  }
</style>
